var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTv = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M32.5 26.779a.723.723 0 0 1-.725.72H8.225a.723.723 0 0 1-.725-.72V11.99c0-.4.325-.723.725-.723h23.55c.4 0 .725.323.725.723v14.788Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M9.224 14.484c0-.535.436-.969.973-.969h14.941c.537 0 .973.434.973.969v9.717a.97.97 0 0 1-.973.969h-14.94a.97.97 0 0 1-.974-.969v-9.717ZM29.448 15.893c.714 0 1.293-.568 1.293-1.269 0-.702-.58-1.27-1.293-1.27-.714 0-1.293.568-1.293 1.27 0 .701.579 1.27 1.293 1.27ZM29.448 20.11c.714 0 1.293-.567 1.293-1.268s-.58-1.27-1.293-1.27c-.714 0-1.293.568-1.293 1.27 0 .7.579 1.269 1.293 1.269ZM15.183 4.792l4.62 6.23a.22.22 0 0 0 .174.086h.035a.22.22 0 0 0 .174-.086l4.59-6.23"
}))));
export default SvgTv;